import { connect } from 'react-redux';
import pick from 'lodash/pick';
import { compose } from '../../../../src/web/utils/react';
import { widget } from '../../../../src/web/components/widgets/decorators';
import { BUILDER } from '../../../../src/shared/abilities';
import { findId as findFacilityId } from '../../../../src/web/store/modules/facilities';
import {
  showReviewModal as showModal,
  hideReviewModal as hideModal,
  submit,
} from '../../../../src/web/store/modules/reviews';
import { NAME, ID } from './properties';
import ReviewButton from './ReviewButton';


export const Core = connect(
  (state) => {
    const props = {
      facilityId: findFacilityId({}, state),
    };

    if (!state.reviews) {
      return props;
    }

    return {
      ...pick(state.reviews, ['showReviewModal', 'isSubmitting', 'success', 'error', 'review']),
      ...props,
    };
  },
  {
    handleShowModal: showModal,
    handleHideModal: hideModal,
    handleSubmit: submit,
  },
)(ReviewButton);

const component = compose(
  widget(
    { name: NAME, category: 'Reviews', componentId: ID },
    {
      menu: { items: ['delete'] },
    },
  ),
)(Core);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
